import React, { useState, useEffect } from 'react';
import { FaPhone, FaEnvelope, FaFacebookF, FaMapMarkerAlt, FaBus, FaDoorOpen } from 'react-icons/fa';
import { API_BASE } from '../config/api';
import siteContentStatic from '../data/siteContent.json';
import './RenseignementsPratiques.css';

function RenseignementsPratiques() {
  const [data, setData] = useState(siteContentStatic.contact);

  useEffect(() => {
    fetch(`${API_BASE}/api/site-content`)
      .then(res => { if (!res.ok) throw new Error(); return res.json(); })
      .then(content => { if (content.contact) setData(content.contact); })
      .catch(() => {});
  }, []);

  return (
    <div className="contact-page">
      {/* Hero */}
      <section className="contact-hero">
        <div className="contact-hero-content">
          <h1>{data.title}</h1>
          <p className="contact-lead">
            N'hésitez pas à nous contacter pour toute question ou pour en savoir plus sur nos actions.
          </p>
        </div>
      </section>

      {/* Contact info cards */}
      <section className="contact-info-section">
        <div className="contact-container">
          <div className="contact-info-grid">
            <div className="contact-info-card">
              <div className="contact-info-icon">
                <FaPhone />
              </div>
              <h3>Téléphone</h3>
              <p>
                <a href={`tel:${data.phone.replace(/\s/g, '')}`}>{data.phone}</a>
              </p>
            </div>

            <div className="contact-info-card">
              <div className="contact-info-icon">
                <FaEnvelope />
              </div>
              <h3>Email</h3>
              <p>
                <a href={`mailto:${data.email}`}>{data.email}</a>
              </p>
            </div>

            <div className="contact-info-card">
              <div className="contact-info-icon">
                <FaFacebookF />
              </div>
              <h3>Facebook</h3>
              <p>
                <a href={data.facebook} target="_blank" rel="noopener noreferrer">
                  Suivez-nous sur Facebook
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Access / directions */}
      <section className="contact-access-section">
        <div className="contact-container">
          <div className="contact-access-card">
            <div className="contact-access-text">
              <h2>Comment nous trouver</h2>

              <div className="access-detail">
                <div className="access-detail-icon">
                  <FaMapMarkerAlt />
                </div>
                <div className="access-detail-text">
                  <h4>Adresse</h4>
                  <p>{data.address}</p>
                </div>
              </div>

              <div className="access-detail">
                <div className="access-detail-icon">
                  <FaBus />
                </div>
                <div className="access-detail-text">
                  <h4>Bus 5141</h4>
                  <p>{data.transport}</p>
                </div>
              </div>

              <div className="access-detail">
                <div className="access-detail-icon">
                  <FaDoorOpen />
                </div>
                <div className="access-detail-text">
                  <h4>Sur place</h4>
                  <p>Prendre l'allée du cimetière Saint Louis, qui longe la chapelle. RIVE se situe au milieu de l'allée, sur la gauche (porte bleue).</p>
                </div>
              </div>
            </div>

            <div className="contact-access-image">
              {data.image && (
                <img
                  src={data.image}
                  alt="RIVE Versailles"
                  loading="lazy"
                />
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Contact form */}
      <section className="contact-form-section">
        <div className="contact-container">
          <div className="contact-form-header">
            <h2>Envoyez-nous un message</h2>
            <p>Remplissez le formulaire ci-dessous et nous vous répondrons dans les plus brefs délais.</p>
          </div>

          <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
            <div className="form-row">
              <div className="form-group">
                <label>
                  Votre nom <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="your-name"
                  className="form-input"
                  placeholder="Entrez votre nom"
                  required
                />
              </div>
              <div className="form-group">
                <label>
                  Votre email <span className="required">*</span>
                </label>
                <input
                  type="email"
                  name="your-email"
                  className="form-input"
                  placeholder="Entrez votre email"
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label>Sujet</label>
              <input
                type="text"
                name="your-subject"
                className="form-input"
                placeholder="Objet de votre message"
              />
            </div>

            <div className="form-group">
              <label>
                Votre message <span className="required">*</span>
              </label>
              <textarea
                name="your-message"
                className="form-textarea"
                placeholder="Écrivez votre message ici..."
                required
              />
            </div>

            <button type="submit" className="form-submit-btn">
              Envoyer le message
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}

export default RenseignementsPratiques;
